import { createContext } from 'react'

export interface AuthState {
  isAuthenticated: boolean
  hasAnyRole: boolean
  isAdmin: boolean
  roles: string[]
  loading: boolean
  error: Error | null
  retry: () => void
  roleOverrideActive: boolean
}

export const CurrentUserContext = createContext<AuthState | undefined>(undefined)
